module.exports = __webpack_public_path__ + "img/longde.4d539f91.png";